export const SETTINGS = "SETTINGS";
export const SETTINGS_LOADING = "SETTINGS_LOADING";
export const SETTINGS_ORG = "SETTINGS_ORG";
export const SETTINGS_ORG_LOADING = "SETTINGS_ORG_LOADING";
